import { HStack } from '@chakra-ui/react';
import React from 'react';
import { MaintenanceModalDispDeleteLabel } from '../atoms/MaintenanceModalDispDeleteLabel';
import { MaintenanceModalDispLabel } from '../atoms/MaintenanceModalDispLabel';
import { AdminUsersStateType } from '../../pages/AdminUsersMaintenance';
import { CategoryStateType } from '../../pages/CategoryMaintenance';
import { MailingListStateType } from '../../pages/MailingListMaintenance';
import { PhrasesStateType } from '../../pages/PhrasesMaintenance';
import { SettingsStateType } from '../../pages/SettingsMaintenance';
import { TrainGroupsStateType } from '../../pages/TrainGroupsMaintenance';
import { TrainsStateType } from '../../pages/TrainsMaintenance';

export type chooseDataStateType =
  | AdminUsersStateType
  | CategoryStateType
  | TrainsStateType
  | TrainGroupsStateType
  | PhrasesStateType
  | MailingListStateType
  | SettingsStateType;
interface props {
  data: chooseDataStateType;
  setChooseData: (data: chooseDataStateType) => void;
  onOpenBrowse: () => void;
  onOpenEdit: () => void;
  onToggle: () => void;
}

export const MaintenanceModalDispLabels: React.FC<props> = (props) => {
  const { data, setChooseData, onOpenBrowse, onOpenEdit, onToggle } = props;

  return (
    <>
      <HStack>
        <MaintenanceModalDispLabel
          data={data}
          setChooseData={setChooseData}
          onOpen={onOpenBrowse}
          dispString={'閲覧'}
        />
        <MaintenanceModalDispLabel
          data={data}
          setChooseData={setChooseData}
          onOpen={onOpenEdit}
          dispString={'編集'}
        />
        <MaintenanceModalDispDeleteLabel
          data={data}
          setChooseData={setChooseData}
          onToggle={onToggle}
        />
      </HStack>
    </>
  );
};
